<script lang="tsx">
/* eslint-disable @typescript-eslint/no-empty-function */
  import {
    defineComponent, PropType, withModifiers,
    onUnmounted, computed,
  } from 'vue'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerProgress from '@xhs/yam-beer/cmp/common/Spinner/ProgressSpinner.vue'
  import RemoveIcon from './RemoveIcon.vue'

  const URL_MISSING_PIC = 'https://ci.xiaohongshu.com/e25d01dd-e150-4003-9b8c-81ab3fb69dc1@r_640w_640h.jpg'
  export default defineComponent({
    name: 'BeerImageBox',
    props: {
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      imageBoxBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      filename: {
        type: String,
        default: '',
      },
      error: {
        type: String,
        default: undefined,
      },
      item: {
        type: Object,
        default: () => ({}),
      },
      handleRemove: {
        type: Function,
        default: () => () => {},
      },
    },
    setup(props, { slots, attrs }) {
      let url = ''
      const revokeUrl = () => {
        if (url) {
          window.URL.revokeObjectURL(url)
        }
      }
      const getUrlFromFile = (file: File) => {
        revokeUrl()
        url = window.URL.createObjectURL(file)
        return url
      }
      onUnmounted(() => {
        revokeUrl()
      })
      const src = computed(() => {
        if (props.item.file) {
          return getUrlFromFile(props.item.file)
        }
        return props.item.url || URL_MISSING_PIC
      })

      return () => {
        const {
          item, readonly,
        } = props
        return (
        <NewBsBox
          bs={{
            'cmp.imageUpload': 'card',
            'cmp.imageUpload.cardState': 'default',
            mr: 12,
            ...props.bs,
          }}
          context={props}
          data-error={!!item.error || undefined}
          {...attrs}
        >
          <NewBsBox
            bs={{
              'cmp.imageUpload': 'box',
              'cmp.imageUpload.boxVariant': 'img',
              ...props.imageBoxBs,
            }}
            data-slot="box"
          >
            <NewBsBox
              bs={{ 'cmp.imageUpload': 'img' }}
              as="img"
              {...{
                src: src.value,
                alt: item.fileItem,
              }}
            />

            {(item.uploadPercent < 100 && !item.error) && (
              <NewBsBox bs={{ 'cmp.imageUpload.boxVariant': 'mask' }}>
                <BeerProgress
                  indicator={true}
                  size={36}
                  progress={item.uploadPercent}
                />
              </NewBsBox>
            )}

            {!readonly && (
              <RemoveIcon
                bs={{
                  position: 'absolute',
                  right: '-1px',
                  top: '-1px',
                  borderTopLeftRadius: 0,
                  borderBottomRightRadius: 0,
                }}
                {...{
                  onClick: withModifiers(() => props.handleRemove(props.item), ['stop']),
                }}
              />
            )}
          </NewBsBox>
          {slots.filename ? slots.filename : (
            <NewBsBox
              bs={{ 'cmp.imageUpload': 'fileName' }}
              data-error={!!props.error || null}
              data-slot="filename">
              { props.error || props.filename }
            </NewBsBox>
          )}
        </NewBsBox>
      )
      }
    },
  })
</script>
